import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { Container } from 'ui/container'
import { PageTitle } from '../../features/common/page-title'
import { Categories } from 'features/faq/categories'
import { Detail } from 'features/faq/detail'
import c from './assets/sass/page.module.scss'

const VALID_CATEGORIES = ['tapper', 'referrals', 'tasks', 'shop', 'modes', 'leaderboard']

const FaqPage = () => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()
    const categoryParam = searchParams.get('category')
    const [selectedCategory, setSelectedCategory] = useState(null)

    useEffect(() => {
        if (categoryParam && VALID_CATEGORIES.includes(categoryParam)) {
            setSelectedCategory(categoryParam)
        }
    }, [categoryParam])

    return (
        <div className={c.component}>
            {!selectedCategory ? (
                <>
                    <PageTitle
                        title={t('pages.faq.title')}
                    />
                    <Container>
                        <div className={c.subtitle}>
                            {t('pages.faq.subtitle')}
                        </div>
                        <Categories onSelect={setSelectedCategory} />
                    </Container>
                </>
            ) : (
                <Container>
                    <Detail
                        category={selectedCategory}
                        onBack={() => setSelectedCategory(null)}
                    />
                </Container>
            )}
        </div>
    )
}

export default FaqPage
